import { FunctionComponent, useCallback } from 'react'
import { Tag, Text, Tooltip, getTheme } from '@conexasaude/conexa-hero'
import Icon from '@/components/RebrandedHeroIcons'
import Modal from '@/components/RebrandedModal'
import { useModalContext } from '@/components/RebrandedModal/contexts/ModalContext'
import { useStyles } from './styles'
import { capitalize } from '@/utils/fnUtils'
import { useFirebaseContext } from '@/modules/Firebase/contexts/FirebaseContext'
import { DependentsModalProps } from './types'

const DependentsModal: FunctionComponent<DependentsModalProps> = ({
  childDependents,
  adultDependents,
  activatedChildren,
}) => {
  const styles = useStyles()
  const theme = getTheme()
  const { closeModal } = useModalContext()
  const { logAnalyticsEvent } = useFirebaseContext()

  const handleCloseModalAndSendEvents = useCallback(() => {
    closeModal()
    logAnalyticsEvent('Pac_AtivacaoLogada_OkEntendi')
  }, [closeModal, logAnalyticsEvent])

  return (
    <Modal
      primaryActionLabel="Ok, entendi"
      primaryAction={handleCloseModalAndSendEvents}
      id="DEPENDENTS_MODAL"
    >
      <div css={styles.modalContent}>
        <div css={styles.subtitle}>
          <Text
            color={theme.colors.brand.primary[500]}
            variant="paragraphSmall"
          >
            Para dependentes crianças e adolescentes, o acesso é feito com os
            mesmos dados da conta titular. Dependentes adultos precisam criar
            uma conta separada.
          </Text>
        </div>
        <div css={styles.dependentSection}>
          <Text
            css={styles.listTitle}
            color={theme.colors.neutral[300]}
            variant="paragraphSmall"
          >
            Dependentes crianças e adolescentes
          </Text>

          <div css={styles.dependentList}>
            {childDependents?.map(dependent => {
              const isActive = dependent?.flagAtivo || activatedChildren
              return (
                <div
                  css={styles.dependentListItem}
                  key={dependent?.idDependente}
                >
                  <div css={styles.tag}>
                    <Tag variant={isActive ? 'success' : 'error'} size="small">
                      {isActive ? 'Ativo' : 'Inativo'}
                    </Tag>
                  </div>
                  <Text
                    variant="subheading"
                    color={theme.colors.brand.primary[500]}
                  >
                    {capitalize(dependent?.nome?.toLocaleLowerCase())}
                  </Text>
                </div>
              )
            })}
          </div>
          <Text
            css={styles.listTitle}
            color={theme.colors.neutral[300]}
            variant="paragraphSmall"
          >
            Dependentes adultos
            <Tooltip label="Dependentes adultos precisam criar uma conta separada.">
              <span>
                <Icon name="info" size="small" />
              </span>
            </Tooltip>
          </Text>
          <div css={styles.dependentList}>
            {adultDependents?.map(dependent => {
              return (
                <div
                  css={styles.dependentListItem}
                  key={dependent?.idDependente}
                >
                  <Tag
                    variant={dependent?.flagAtivo ? 'success' : 'error'}
                    size="small"
                  >
                    {dependent?.flagAtivo ? 'Ativo' : 'Inativo'}
                  </Tag>
                  <Text
                    variant="subheading"
                    color={theme.colors.brand.primary[500]}
                  >
                    {capitalize(dependent?.nome?.toLocaleLowerCase())}
                  </Text>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </Modal>
  )
}

export { DependentsModal }
